import { useState } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/router'

import { useViewport } from 'contexts/viewport'
import styles from 'styles/help_details.module.scss'

export default function HelpDetailsMasthead({ query }) {
  const router = useRouter()
  const { isMobile } = useViewport()
  const [queryInput, setQueryInput] = useState(query)

  const resetSearchQuery = () => {
    router.push({
      pathname: '/help-details/search',
      query: {
        ...(queryInput && { q: queryInput }),
      },
    })
  }

  const handleSubmitQueryInput = e => {
    if (e.key === 'Enter') {
      resetSearchQuery()
    }
  }

  const handleChangeQueryInput = e => {
    setQueryInput(e.target.value || '')
  }

  return (
    <div className={styles.header_section}>
      <div className={styles.header_bg}>
        {isMobile ? (
          <div className={styles.header_bg_img}>
            <Image src="/images/help_details/background_mobile.png" alt="Game for Every Team" layout="fill" />
          </div>
        ) : (
          <div className={styles.header_bg_img}>
            <Image src="/images/help_details/background.png" alt="Game for Every Team" layout="fill" />
          </div>
        )}
      </div>
      <div className={styles.header_container}>
        <div className={styles.header_left}>
          <div className={'hero ' + styles.header_title}>Team Games Help</div>
          <div className={styles.header_search_container}>
            {!isMobile && (
              <div className={styles.header_search_icon}>
                <Image
                  src="/images/help_details/search_icon.png"
                  alt="Search Icon"
                  width={17}
                  height={17}
                  onClick={resetSearchQuery}
                />
              </div>
            )}
            <div className={styles.header_search_border} />
            <input
              className={styles.header_search_input}
              placeholder="Search FAQ, Announcements, etc..."
              onKeyDown={handleSubmitQueryInput}
              value={queryInput}
              onChange={handleChangeQueryInput}
            />
            {isMobile && (
              <div className={styles.header_search_icon_mobile}>
                <Image
                  src="/images/help_details/search_icon_mobile.png"
                  alt="Search Icon"
                  layout="fill"
                  onClick={resetSearchQuery}
                />
              </div>
            )}
          </div>
          <div className={'description_small ' + styles.header_desc}>
            From how to create a team Outing to pricing information, find all answers and tips here!
          </div>
        </div>
        <div className={styles.header_right}>
          <div className={styles.header_right_image_container}>
            <Image src="/images/help_details/header.png" alt="Header" layout="fill" />
          </div>
        </div>
      </div>
    </div>
  )
}
